export default "__VITE_ASSET__BukQdzw8__"